function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60Z",
    fill: "#D5F4E3",
    style: {
      fill: "#D5F4E3",
      fill: "color(display-p3 0.8353 0.9569 0.8902)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 60C12 33.4903 33.4903 12 60 12C86.5097 12 108 33.4903 108 60C108 86.5097 86.5097 108 60 108C33.4903 108 12 86.5097 12 60Z",
    fill: "#96E4B9",
    style: {
      fill: "#96E4B9",
      fill: "color(display-p3 0.5882 0.8941 0.7255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 60C24 40.1178 40.1178 24 60 24C79.8823 24 96 40.1178 96 60C96 79.8823 79.8823 96 60 96C40.1178 96 24 79.8823 24 60Z",
    fill: "#2DCA72",
    style: {
      fill: "#2DCA72",
      fill: "color(display-p3 0.1765 0.7922 0.4471)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_17057)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52_17057",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 44,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9403 52.3456L71.0604 50.4543L55.9697 65.4536L48.94 58.4699L47.0605 60.3617L55.9701 69.2129L72.9403 52.3456Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_52_17057)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 32,
    height: 32,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_17057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(44 44)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.935892a11f3357d4fa29dbce4427fcc8.svg";
export { ForwardRef as ReactComponent };